export const FolderIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.33301 12.6667V5.03268C1.33301 4.07011 1.33301 3.58881 1.49522 3.21098C1.69747 2.7399 2.07291 2.36447 2.54399 2.16221C2.92182 2 3.39837 2 4.36569 2H4.69508C5.09847 2 5.48017 2.18263 5.73328 2.49673L6.94467 4M6.94467 4H10.6663C11.5997 4 12.0665 4 12.423 4.18165C12.7366 4.34145 12.9915 4.59641 13.1513 4.91001C13.333 5.26653 13.333 5.73325 13.333 6.66667V7.33333M6.94467 4H4.66634"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.10502 10.3429L2.30396 9.84772C2.7932 8.62985 3.03783 8.02099 3.54794 7.67712C4.05805 7.33325 4.71672 7.33325 6.03405 7.33325H11.4076C13.1999 7.33325 14.0961 7.33325 14.4945 7.91905C14.8928 8.50492 14.56 9.33338 13.8943 10.9903L13.6954 11.4855C13.2061 12.7033 12.9615 13.3122 12.4514 13.6561C11.9413 13.9999 11.2826 13.9999 9.96527 13.9999H4.59175C2.79941 13.9999 1.90324 13.9999 1.50489 13.4141C1.10653 12.8283 1.43936 11.9998 2.10502 10.3429Z"
      stroke="currentColor"
      strokeLinejoin="round"
    />
  </svg>
);
